import { GET_SUBCATEGORIES_REQUEST, GET_SUBCATEGORIES_SUCCESS, GET_SUBCATEGORIES_FAILURE } from '../actions/getSubcategories';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export default function getSubcategoriesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SUBCATEGORIES_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_SUBCATEGORIES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_SUBCATEGORIES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}